import { cn as e } from "../../cn.js";
import { getStyles as t } from "./style.js";
import { FormSetErrorText as n, FormSetHelperText as r, FormSetLabel as i } from "../shared/form-primitives.js";
import { Fragment as a, jsx as o, jsxs as s } from "react/jsx-runtime";
import { Fieldset as c } from "@ark-ui/react";
import { RadioGroup as l } from "@ark-ui/react/radio-group";
// src/design/forms/radio/index.tsx
var u = ({ items: n, label: r, config: u, className: d, helperText: f, errorText: p, orientation: m, ...h }) => {
	let g = t({
		size: u?.size,
		variant: u?.variant,
		orientation: m || u?.orientation
	}), _ = !!p || h.invalid;
	return /* @__PURE__ */ o(c.Root, {
		invalid: _,
		children: /* @__PURE__ */ s(l.Root, {
			invalid: _,
			className: e(g.root(), u?.orientation === "vertical" ? "gap-2" : "gap-0", d),
			...h,
			children: [
				r && /* @__PURE__ */ o(i, {
					required: h.required,
					disabled: h.disabled,
					children: r
				}),
				/* @__PURE__ */ o("div", {
					className: g.defaultWrapper(),
					children: n.map((e) => /* @__PURE__ */ s(l.Item, {
						value: e.value,
						disabled: e.disabled,
						className: g.item(),
						children: [/* @__PURE__ */ o(l.Context, { children: (t) => /* @__PURE__ */ s(a, { children: [/* @__PURE__ */ o("div", {
							className: g.controlWrapper(),
							children: /* @__PURE__ */ o(l.ItemControl, {
								className: g.control(t.value === e.value),
								children: /* @__PURE__ */ o("div", {
									className: g.controlIndicator(),
									children: /* @__PURE__ */ o("div", { className: g.controlIndicatorDot(t.value === e.value) })
								})
							})
						}), /* @__PURE__ */ o(l.ItemText, {
							className: g.itemText(),
							children: e.label
						})] }) }), /* @__PURE__ */ o(l.ItemHiddenInput, {})]
					}, e.value))
				}),
				f && !p && /* @__PURE__ */ o(v, { children: f }),
				p && /* @__PURE__ */ o(y, { children: p })
			]
		})
	});
}, d = ({ children: n, className: r, config: i, fieldsetProps: a, ...s }) => {
	let u = t({ orientation: i?.orientation });
	return /* @__PURE__ */ o(c.Root, {
		...a,
		invalid: a?.invalid || s.invalid,
		children: /* @__PURE__ */ o(l.Root, {
			className: e(u.root(), r),
			...s,
			children: n
		})
	});
}, f = ({ children: e, className: t, required: n, ...r }) => /* @__PURE__ */ o(i, {
	className: t,
	required: n,
	...r,
	children: e
}), p = ({ children: n, className: r, ...i }) => {
	let a = t();
	return /* @__PURE__ */ o(l.Indicator, {
		className: e(a.indicator(), r),
		...i,
		children: n
	});
}, m = ({ children: n, className: r, config: i, ...a }) => {
	let s = t({ size: i?.size });
	return /* @__PURE__ */ o(l.Item, {
		className: e(s.item(), r),
		...a,
		children: n
	});
}, h = ({ children: n, className: r, config: i, checked: a, ...c }) => {
	let u = t({
		size: i?.size,
		variant: i?.variant
	});
	return a === void 0 ? /* @__PURE__ */ o(l.ItemContext, { children: (t) => /* @__PURE__ */ o("div", {
		className: u.controlWrapper(),
		children: /* @__PURE__ */ s(l.ItemControl, {
			className: e(u.control(t.checked), r),
			...c,
			children: [/* @__PURE__ */ o("div", {
				className: u.controlIndicator(),
				children: /* @__PURE__ */ o("div", { className: u.controlIndicatorDot(t.checked) })
			}), n]
		})
	}) }) : /* @__PURE__ */ o("div", {
		className: u.controlWrapper(),
		children: /* @__PURE__ */ s(l.ItemControl, {
			className: e(u.control(a), r),
			...c,
			children: [/* @__PURE__ */ o("div", {
				className: u.controlIndicator(),
				children: /* @__PURE__ */ o("div", { className: u.controlIndicatorDot(a) })
			}), n]
		})
	});
}, g = ({ children: n, className: r, ...i }) => {
	let a = t();
	return /* @__PURE__ */ o(l.ItemText, {
		className: e(a.itemText(), r),
		...i,
		children: n
	});
}, _ = ({ className: n, ...r }) => {
	let i = t();
	return /* @__PURE__ */ o(l.ItemHiddenInput, {
		className: e(i.itemHiddenInput(), n),
		...r
	});
}, v = ({ children: e, ...t }) => /* @__PURE__ */ o(r, {
	...t,
	children: e
}), y = ({ children: e, ...t }) => /* @__PURE__ */ o(n, {
	...t,
	children: e
}), b = Object.assign(u, {
	Context: l.Context,
	Root: d,
	Label: f,
	Indicator: p,
	Item: m,
	ItemControl: h,
	ItemText: g,
	ItemHiddenInput: _,
	ErrorText: y,
	HelperText: v,
	getStyles: t
});
export { b as RigoRadioGroup };

//# sourceMappingURL=index.js.map